import commonAction from "./commonAction";
import * as types from "../constants/actionsTypes";

export const updateCallsDates = body => {
  return dispatch =>
    commonAction(
      dispatch,
      "post",
      "/clients/set-call-date",
      body,
      "CLIENTS_UPDATE_CALLS_DATE",
      "data"
    );
};

export const loadClients = (filter, pager) => {
  const body = {
    filter
  };

  if (pager) {
    body.pager = pager;
  }

  return dispatch =>
    commonAction(dispatch, "get", "newApi/api/v1/cards", body, "CLIENTS_LOAD", "data");
};

export const loadClient = (id) => {

    return dispatch =>
        loadClientAction(id, dispatch)
};

export const loadClientInProfit = () => {
  return dispatch =>
    commonAction(
      dispatch,
      "post",
      "/clients/in-profit",
      null,
      "CLIENTS_IN_PROFIT_LOAD",
      "list"
    );
};

export const loadWaitCallClients = () => {
  return dispatch =>
    commonAction(
      dispatch,
      "post",
      "/clients/wait-for-call",
      null,
      "WAIT_FOR_CALL_CLIENTS_LOAD",
      "list"
    );
};

export const removeClient = id => {
  return dispatch =>
    commonAction(
      dispatch,
      "post",
      "/clients/delete",
      { id },
      "CLIENT_REMOVE",
      "data"
    );
};

export const loadClientsInWorkFullList = () => {
  return dispatch =>
    commonAction(
      dispatch,
      "get",
      "newApi/api/v1/clients/need-to-call",
      null,
      "CLIENTS_FULL_LIST_LOAD",
      "data"
    );
};

export const cardInWork = (id, callback) => {
	return dispatch =>
		commonAction(
			dispatch,
			"post",
			`/cards/in-work/${id}`,
			null,
			"CARD_IN_WORK",
			"client",
			null,
			callback
		);
};

export const cardCancelInWork = (id, callback) => {
	return dispatch =>
		commonAction(
			dispatch,
			"post",
			`/cards/cancel-in-work/${id}`,
			null,
			"CARD_CANCEL_IN_WORK",
			"client",
			null,
			callback
		);
};

export const exportCards = (filter) => {
    const body = {
        filter
    };

    return dispatch =>
        commonAction(dispatch, "post", "/clients/export", body, "CLIENTS_EXPORTED", "data");
};

export const loadClientAction = (id, dispatch) => {
    return commonAction(dispatch, "get", "/clients/" + id, {}, "CLIENTS_LOAD", "data");
}

export const editCardRequest = () => {

    return {
        type: types.CLIENT_CHANGE_REQUEST,
    }
}

export const editCardSuccessfully = (data) => {

    return {
        type: types.CLIENT_CHANGE_SUCCESS,
        client: data
    }
}

export const editCardError = (error) => {
    return {
        type: types.CLIENT_CHANGE_FAILURE,
        error: error
    }
}

export const createCardRequest = () => {

    return {
        type: types.CLIENT_ADD_REQUEST,
    }
};

export const cardCreatedSuccessfully = (redirectUrl) => {

    return {
        type: types.CLIENT_ADD_SUCCESS,
        client: {
            redirect_url: redirectUrl
        }
    }
};

export const cardCreationFailed = (error) => {

    return {
        type: types.CLIENT_ADD_FAILURE,
        error: error
    }
};

export const loadSalesOrdersOfSupplierRequest = () => {

    return {
        type: types.LOAD_SALES_ORDERS_OF_SUPPLIER_REQUEST,
    }
};

export const loadSalesOrdersOfSupplierSuccessfully = (salesOrders) => {

    return {
        type: types.LOAD_SALES_ORDERS_OF_SUPPLIER_SUCCESS,
        salesOrders: salesOrders
    }
};

export const loadSalesOrdersOfSupplierFailed = (error) => {

    return {
        type: types.LOAD_SALES_ORDERS_OF_SUPPLIER_FAILURE,
        error: error
    }
};

export const createSalesOrderRequest = () => {

    return {
        type: types.CREATE_SALES_ORDER_REQUEST,
    }
};

export const createSalesOrderSuccessfully = () => {

    return {
        type: types.CREATE_SALES_ORDER_SUCCESS,
    }
};

export const createSalesOrderFailed = (error) => {

    return {
        type: types.CREATE_SALES_ORDER_FAILURE,
        error: error
    }
};

export const cancelSalesOrderRequest = () => {

    return {
        type: types.CANCEL_SALES_ORDER_REQUEST,
    }
};

export const cancelSalesOrderSuccessfully = () => {

    return {
        type: types.CANCEL_SALES_ORDER_SUCCESS,
    }
};

export const cancelSalesOrderFailed = (error) => {

    return {
        type: types.CANCEL_SALES_ORDER_FAILURE,
        error: error
    }
};



// WEBPACK FOOTER //
// ./actions/clientsActions.js